<template>
    <ManualsAndVideos></ManualsAndVideos>
</template>

<script>
import ManualsAndVideos from "../../components/Safety/ManualsAndVideos.vue";
import AuthLayout from "../../Layouts/AuthLayout.vue";

export default {
    name: "Manuals_AndVideos",
    components: { ManualsAndVideos, AuthLayout },
};
</script>